import { render, staticRenderFns } from "./OpenBolPage.vue?vue&type=template&id=7bda723a&scoped=true"
import script from "./OpenBolPage.vue?vue&type=script&lang=js"
export * from "./OpenBolPage.vue?vue&type=script&lang=js"
import style0 from "./OpenBolPage.vue?vue&type=style&index=0&id=7bda723a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bda723a",
  null
  
)

export default component.exports